<template>
  <div class="quiz-form">
    <div class="actions" v-if="tag.template === 'quizzes'">
      <a class="icon-button save" href="#" v-on:click.prevent="onSave">
       {{this.addQuiz ? 'Add' : 'Save'}}
      </a>
      <a class="icon-button" href="#" v-on:click.prevent="onClose">
       Close
      </a>
    </div>
    <label for="quiz_type">Quiz Type</label>
    <select v-model="type" @change="updateField('type', type)">
      <option value="multipleChoice">Multiple choice</option>
      <option value="singleChoice">Single choice</option>
      <option value="sortable">Sortable</option>
    </select>
    <label for="quiz_image">Answers with Image</label>
    <input type="checkbox" id="quiz_image" v-model="hasImage" v-on:blur="updateField('hasImage', $event.target.checked)" />
    <label for="quiz_question">Question<lang-toggler :lang="question.lang" @input="question.lang = $event" @applyAll="onApplyToAllLangs(question, $event)"/></label>
    <textarea id="quiz_question" v-model="question[question.lang]" v-on:blur="updateLangField('question', question.lang, $event)" />
    <ul v-sortable="{onEnd: reorder, handle: '.swap'}">
      <li v-for="(answer, key) in answers" v-bind:key="keyPart + key">
        <!--
        <label :for="'quiz_answer_' + key">{{'Answer ' + (key + 1)}}<lang-toggler :lang="answer.lang" @input="answer.lang = $event"/></label>
        -->
        <AnswerField :id="'quiz_answer_' + key" type="text" :quizId="tag.id" :answer="answer" :quizHasImage="hasImage" v-on:update="(data) => updateAnswer(key, data, answer.lang)" v-on:delete="deleteAnswer(key)" :quizType="type" />
      </li>
    </ul>
    <a class="icon-button" href="#" v-on:click.prevent="addAnswer">
      <i class="material-icons">add</i>
    </a>

    <label v-if="!hasImage" for="quiz_alignement">Alignement</label>
    <align-picker v-if="!hasImage" name="quiz_alignement" v-on:pick="updateField('alignement', $event)" :value="alignement" :options="['v-layout', 'h-layout']" />

    <label for="quiz_alignement">Color Scheme</label>
    <color-scheme-select v-on:pick="updateField('colorScheme', $event)" :modelItem="colorScheme" :value="colorScheme.key" :options="colorOptions" />

    <label for="quiz_instruction">Instruction<lang-toggler :lang="instruction.lang" @input="instruction.lang = $event" @applyAll="onApplyToAllLangs(instruction, $event)"/></label>
    <input type="text" id="quiz_instruction" v-model="instruction[instruction.lang]" v-on:blur="updateLangField('instruction', instruction.lang, $event)" />

    <label for="quiz_correct_feedback">Correct Feedback<lang-toggler :lang="correctFeedback.lang" @input="correctFeedback.lang = $event" @applyAll="onApplyToAllLangs(correctFeedback, $event)"/></label>
    <input type="text" id="quiz_correct_feedback" v-model="correctFeedback[correctFeedback.lang]" v-on:blur="updateLangField('correctFeedback', correctFeedback.lang, $event)" />

    <label for="quiz_wrong_feedback">Wrong Feedback<lang-toggler :lang="wrongFeedback.lang" @input="wrongFeedback.lang = $event" @applyAll="onApplyToAllLangs(wrongFeedback, $event)"/></label>
    <input type="text" id="quiz_wrong_feedback" v-model="wrongFeedback[wrongFeedback.lang]" v-on:blur="updateLangField('wrongFeedback', wrongFeedback.lang, $event)" />

    <label for="quiz_submitButtonText">Submit Button Text<lang-toggler :lang="submitButtonText.lang" @input="submitButtonText.lang = $event" @applyAll="onApplyToAllLangs(submitButtonText, $event)"/></label>
    <input type="text" id="quiz_submitButtonText" v-model="submitButtonText[submitButtonText.lang]" v-on:blur="updateLangField('submitButtonText', submitButtonText.lang, $event)" />

    <label for="quiz_feedback_time">Time for Feedback</label>
    <input type="number" id="quiz_feedback_time" v-model="feedbackTime" v-on:blur="updateField('feedbackTime', $event)" />

    <label>Correct Target</label>
    <time-picker 
      :tags="tags"
      :value="correctTarget"
      :frameRate="getFrameRate"
      @newTime="(time) => onTimeChanged('correctTarget', time)">
    </time-picker>
    <!---->
    <label>Incorrect Target</label>
    <time-picker 
      :tags="tags"
      :value="incorrectTarget"
      :frameRate="getFrameRate"
      @newTime="(time) => onTimeChanged('incorrectTarget', time)">
    </time-picker>
    <!---->

    <label for="quiz_max_tries">Max Tries</label>
    <input type="number" id="quiz_max_tries" v-model="maxTries" v-on:blur="updateField('maxTries', $event)" />

    <div v-if="maxTries && maxTries > 0">
      <label for="quiz_correct_feedback">Max tries Feedback<lang-toggler :lang="maxTriesFeedback.lang" @input="maxTriesFeedback.lang = $event" @applyAll="onApplyToAllLangs(maxTriesFeedback, $event)" /></label>
      <input type="text" id="quiz_correct_feedback" v-model="maxTriesFeedback[maxTriesFeedback.lang]" v-on:blur="updateLangField('maxTriesFeedback', maxTriesFeedback.lang, $event)" />

      <div>
        <label for="quiz_max_tries_behaviour">if max tries</label>
        <choose-behaviour v-on:pick="storeMetaData" :modelItem="behaviour" />
      </div>
    </div>

    <label for="quiz_skippable">Skippable</label>
    <input type="checkbox" id="quiz_skippable" v-model="skippable" v-on:blur="updateField('skippable', $event.target.checked)" />
    <div v-if="tag.template === 'quizzes'">
      <a class="icon-button save" href="#" v-on:click.prevent="onSave">
       {{this.addQuiz ? 'Add' : 'Save'}}
      </a>
      <a class="icon-button" href="#" v-on:click.prevent="onClose">
       Close
      </a>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations, mapGetters } from 'vuex'
import AnswerField from './answerField'
import * as Sortable from 'sortablejs/Sortable.js'
import AlignPicker from './alignPicker'
import ColorSchemeSelect from './colorSchemeSelect'
import LangToggler from './langToggler'
import { multiLangTextObject } from './../../utils/multiLang'
import ChooseBehaviour from "./chooseBehaviour"
import timePicker from '../core/timePicker'
import guid from '../../utils/guid'

const colorOptions = [
  {
    id: 'quiz-1',
    label: 'default'
  },
  {
    id: 'quiz-transparent-light',
    label: 'semi transparent for light background'
  },
  {
    id: 'quiz-transparent-dark',
    label: 'semi transparent for dark background'
  },
  {
    id: 'quiz-custom-color',
    label: 'custom'
  },
  {
    id: 'quiz-custom-color-2',
    label: 'custom 2'
  }
]

export default {
  name: 'image-quiz-form',

  components: {
    AnswerField,
    AlignPicker,
    ColorSchemeSelect,
    LangToggler,
    ChooseBehaviour,
    'time-picker': timePicker
  },

  directives: {
    sortable: {
      inserted(el, binding) {
        Sortable.create(el, binding.value)
      }
    }
  },

  props: ['tag'],

  data() {
    console.log("prepare data")
    const meta = (this.tag && this.tag.meta) || {}
    const quiz = (meta && meta.quiz) || {}
    this.addQuiz = meta.quizzes && meta.quizzes.length === 0

    return {
      colorOptions: colorOptions,
      keyPart: new Date().toTimeString(),
      name: meta.name,
      id: quiz.id,
      question: multiLangTextObject(quiz.question),
      instruction: multiLangTextObject(quiz.instruction),
      correctFeedback: multiLangTextObject(quiz.correctFeedback), // || 'Richtig!',
      wrongFeedback: multiLangTextObject(quiz.wrongFeedback), // || 'Falsch!',
      submitButtonText: multiLangTextObject(quiz.submitButtonText),
      feedbackTime: quiz.feedbackTime || 3,
      isUserSelected: false,
      type: quiz.type || 'multipleChoice',
      alignement: quiz.alignement || 'v-layout',
      colorScheme: quiz.colorScheme || {},
      answers: quiz.answers || [multiLangTextObject()],
      correctTarget: quiz.correctTarget,
      incorrectTarget: quiz.incorrectTarget,
      hasImage: quiz.hasImage || false,
      maxTries: quiz.maxTries,
      maxTriesFeedback: multiLangTextObject(quiz.maxTriesFeedback),
      skippable: quiz.skippable !== undefined ? quiz.skippable : true,
      behaviour: quiz.behaviour || {
        value: {}
      },
      value: 0
    }
  },

  computed: {
    ...mapState(['selection']),
    ...mapGetters(['currentTime', 'tags', 'getFrameRate', 'videoDuration'])
  },

  created() {
    console.log(this.tag)
    console.log("quiz created")
  },

  methods: {
    ...mapMutations(['updateQuiz', 'setPlayerTime', 'updateQuizzes', 'addQuizToQuizzes']),

    onTimeChanged: function (field, time) {
      const newTime = time > this.videoDuration ? this.videoDuration - 0.1 : time
      this.updateField(field, newTime)
    },

    updateField(field, eventOrValue) {
      console.log("updateField", field, eventOrValue)
      this[field] = eventOrValue.target ? eventOrValue.target.value : eventOrValue

      if (field === 'hasImage') {
        this['alignement'] = eventOrValue ? 'h-layout' : 'v-layout'
      }

      this.updateTagQuiz()
    },

    updateLangField(field, lang, eventOrValue) {
      console.log("updateField", field, lang, eventOrValue)
      this[field][lang] = eventOrValue.target ? eventOrValue.target.value : eventOrValue
      this.updateTagQuiz()
    },

    updateAnswer(i, answer) {
      console.log("quiz formupdate answer", i, answer)
      if (this.type === 'singleChoice') {
        for (let index = 0; index < this.answers.length; index++) {
          if (index === i) {
            answer.correct = true
            this.answers[index] = answer
            this.$el.querySelector(`#quiz_answer_${index}_selection`).checked = true
          } else {
            this.answers[index].correct = false
            this.$el.querySelector(`#quiz_answer_${index}_selection`).checked = false
          }
        }        
      } else {
        this.answers[i] = answer
      }
      
      this.updateTagQuiz()
    },

    updateTagQuiz() {
      let { question, answers, name, instruction, correctTarget, incorrectTarget, alignement, colorScheme, correctFeedback, wrongFeedback, submitButtonText, maxTries, maxTriesFeedback, feedbackTime, behaviour, type, hasImage, skippable } = this
      let updatedQuiz = { question, answers, name, instruction, correctTarget, incorrectTarget, alignement, colorScheme, correctFeedback, wrongFeedback, submitButtonText, maxTries, maxTriesFeedback, feedbackTime, behaviour, type, hasImage, skippable }
      if (this.tag.template === 'quizzes') {
        if (this.id) {
          this.updateQuizzes({ name, quiz: { ...updatedQuiz,
                          id: this.id } })
        } else {
          this.id = guid()
          this.addQuizToQuizzes({ name, quiz: { ...updatedQuiz,
                          id: this.id } })
        }
      } else {
        this.updateQuiz({ name, quiz: updatedQuiz })
      }
    },

    onSave() {
      this.updateTagQuiz()
      this.$emit('save')
    },

    onClose() {
      this.$emit('close')
    },

    addAnswer() {
      this.answers.push(
        multiLangTextObject()
      )
    },

    storeMetaData(val) {
      console.log("store behaviour meta data", val);
      this.behaviour.value = val;
    },

    deleteAnswer(i) {
      this.answers.splice(i, 1)
      this.keyPart = new Date().toTimeString()
      this.updateTagQuiz()
    },

    reorder({ oldIndex, newIndex }) {
      const movedItem = this.answers.splice(oldIndex, 1)[0]
      this.answers.splice(newIndex, 0, movedItem)
      this.keyPart = new Date().toTimeString()
      this.updateTagQuiz()
    },

    onApplyToAllLangs: function(textObject, ev) {
      let textVal = textObject[ev]
      for (const k in textObject) {
        if (k !== 'lang') {
          textObject[k] = textVal
        }
      }
    }
  }
}

</script>
